function _extends(){return _extends=Object.assign?Object.assign.bind():function(n){for(var e=1;e<arguments.length;e++){var t=arguments[e];for(var r in t)({}).hasOwnProperty.call(t,r)&&(n[r]=t[r])}return n},_extends.apply(null,arguments)}import*as React from"react";import styled from"@emotion/styled";import{Table,Card,Button}from"@wp/src/components/common";import ScoreImpact from"@wp/src/components/screenComponents/portfolio/recommendations/atoms/ScoreImpact";export const StyledLowestPerformersTable=Table;export const StyledPortfolioLowestPerformersCard=styled(Card)`
  & > .ant-card-head {
    padding: 16px 16px 8px 16px;
  }
`;export const StyledLowestPerformersTableColumnTitle=styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${props=>props.theme.colors.neutral600};
`;export const ColumnDataLabel=styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;

  color: ${props=>props.theme.colors.neutral800};
`;export const ViewInvestmentLink=props=>React.createElement(Button,_extends({},props,{type:"link"}));export const StyledScoreImpact=styled(ScoreImpact)`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
`;